export default __webpack_public_path__ + "images/62c8714f6a8cdc7824f0d0d9dca61016.png";